module.exports = __webpack_public_path__ + "img/product-teacher-ckxs-01.2d20cb70.png";